module.exports = __webpack_public_path__ + "img/bulp.3d09f3a9.png";